import { StickyNote, CheckSquare, Calendar, Kanban, BarChart3 } from 'lucide-react';
import { NavigationItem } from '../types/navigation';

export const navigationItems: NavigationItem[] = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    icon: BarChart3,
    path: '/',
    description: 'Overview of your productivity and tasks'
  },
  {
    id: 'notes',
    label: 'Notes',
    icon: StickyNote,
    path: '/notes',
    description: 'Personal notes and documentation'
  },
  {
    id: 'todos',
    label: 'Todo Lists',
    icon: CheckSquare,
    path: '/todos',
    description: 'Task management and collaboration'
  },
  {
    id: 'calendar',
    label: 'Calendar',
    icon: Calendar,
    path: '/calendar',
    description: 'Calendar view of your tasks'
  },
  {
    id: 'kanban',
    label: 'Kanban Board',
    icon: Kanban,
    path: '/kanban',
    description: 'Visual task board organization'
  }
];
